"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reviewData = void 0;
const types_1 = require("./types");
/** Data describing the review and its structure */
exports.reviewData = {
    [types_1.ReviewType.DecouplingCaps]: {
        name: "Decoupling Capacitors",
        type: types_1.ReviewType.DecouplingCaps,
        description: "This review ensures proper placement and selection of decoupling capacitors to minimize noise and stabilize voltage in the PCB design.",
        category: types_1.ReviewCategoryType.PassiveComponents,
        availability: types_1.ReviewAvailability.INTERNAL,
        documentationUrl: "https://docs.flux.ai/tutorials/ai-design-reviews",
        // Columns should match the data returned by the review check
        columns: {
            rcl_ic_with_pin: {
                name: "IC",
                field: "ic_with_pin",
                isDefault: true,
                isLink: true,
                index: 0,
            },
            rcl_large_cap_designator: {
                name: "Large Capacitor Designator",
                field: "large_cap_designator",
                index: 1,
            },
            rcl_large_cap_value: {
                name: "Large Capacitor Value",
                field: "large_cap_value",
                // TODO: make sure this applies to the column header too
                align: types_1.ReviewColumnAlign.RIGHT,
                index: 2,
            },
            rcl_large_cap_voltage: {
                name: "Large Capacitor Voltage",
                field: "large_cap_voltage",
                align: types_1.ReviewColumnAlign.RIGHT,
                index: 3,
            },
            rcl_small_cap_designator: {
                name: "Small Capacitor Designator",
                field: "small_cap_designator",
                index: 4,
            },
            rcl_small_cap_value: {
                name: "Small Capacitor Value",
                field: "small_cap_value",
                align: types_1.ReviewColumnAlign.RIGHT,
                index: 5,
            },
            rcl_small_cap_voltage: {
                name: "Small Capacitor Voltage",
                field: "small_cap_voltage",
                align: types_1.ReviewColumnAlign.RIGHT,
                index: 6,
            },
        },
    },
    [types_1.ReviewType.ResistorPowerRating]: {
        name: "Resistor Power Rating",
        type: types_1.ReviewType.ResistorPowerRating,
        description: "Checks that the power traveling across a given resistor is under its rating with 50% headroom.",
        documentationUrl: "https://docs.flux.ai/tutorials/ai-design-reviews",
        category: types_1.ReviewCategoryType.PassiveComponents,
        availability: types_1.ReviewAvailability.BETA,
        // Columns should match the data returned by the review check
        columns: {
            rcl_resistor: {
                name: "Resistor",
                field: "resistor",
                isDefault: true,
                isLink: true,
                index: 0,
            },
            rcl_headroom_specified: {
                name: "Headroom Specified",
                field: "headroom_specified",
                align: types_1.ReviewColumnAlign.RIGHT,
                index: 1,
            },
            rcl_headroom_actual: {
                name: "Headroom Actual",
                field: "margin",
                align: types_1.ReviewColumnAlign.RIGHT,
                index: 2,
            },
            rcl_power_rating: {
                name: "Power Rating",
                field: "power_rating",
                align: types_1.ReviewColumnAlign.RIGHT,
                isDefault: true,
                index: 3,
            },
            rcl_power_actual: {
                name: "Power Actual",
                field: "calculated_power",
                align: types_1.ReviewColumnAlign.RIGHT,
                isDefault: true,
                index: 4,
            },
        },
    },
    [types_1.ReviewType.PullUpPullDown]: {
        name: "Pull Up/Pull Down Presence",
        type: types_1.ReviewType.PullUpPullDown,
        description: "Checks that IC pins that require pull up or pull down resistors have them.",
        documentationUrl: "https://docs.flux.ai/tutorials/ai-design-reviews",
        category: types_1.ReviewCategoryType.PassiveComponents,
        availability: types_1.ReviewAvailability.BETA,
        columns: {
            "rcl_ic/pin": {
                name: "IC",
                field: "ic/pin",
                isDefault: true,
                isLink: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.CapacitorVoltageRating]: {
        name: "Capacitor Voltage Rating",
        type: types_1.ReviewType.CapacitorVoltageRating,
        description: "Checks that capacitors have appropriate voltage ratings to prevent overheating and ensure reliable circuit operation.",
        category: types_1.ReviewCategoryType.PassiveComponents,
        availability: types_1.ReviewAvailability.BETA,
        // Columns should match the data returned by the review check
        columns: {
            rcl_capacitor: {
                name: "Capacitor",
                field: "capacitor",
                isDefault: true,
                isLink: true,
                index: 0,
            },
            rcl_margin: {
                name: "Headroom",
                field: "margin",
                isDefault: true,
                align: types_1.ReviewColumnAlign.RIGHT,
                index: 1,
            },
            rcl_voltage_rating: {
                name: "Rating",
                field: "voltage_rating",
                align: types_1.ReviewColumnAlign.RIGHT,
                index: 2,
            },
            rcl_voltage: {
                name: "Voltage",
                field: "voltage",
                align: types_1.ReviewColumnAlign.RIGHT,
                index: 3,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckManufacturePartNumber]: {
        name: "Manufacturer Part Number",
        type: types_1.ReviewType.DesignRuleCheckManufacturePartNumber,
        description: "Reports components that have no manufacturer part number.",
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Designator",
                field: "designator",
                isLink: true,
                isDefault: true,
                index: 0,
            },
            rcl_mpn: {
                name: "MPN",
                field: "mpn",
                isDefault: true,
                index: 1,
            },
        },
    },
    [types_1.ReviewType.PartsAvailable]: {
        name: "Parts Available",
        type: types_1.ReviewType.PartsAvailable,
        description: "Checks that all components are available from distributors.",
        category: types_1.ReviewCategoryType.Manufacturing,
        availability: types_1.ReviewAvailability.BETA,
        columns: {
            rcl_designator: {
                name: "Designator",
                field: "designator",
                isDefault: true,
                isLink: true,
                index: 0,
            },
            rcl_stock: {
                name: "Stock",
                field: "stock",
                align: types_1.ReviewColumnAlign.RIGHT,
                isDefault: true,
                index: 1,
            },
            rcl_mpn: {
                name: "MPN",
                field: "mpn",
                index: 2,
            },
            rcl_lifecycle_status: {
                name: "Lifecycle Status",
                field: "lifecycle_status",
                index: 3,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckAirwire]: {
        name: "Airwires",
        type: types_1.ReviewType.DesignRuleCheckAirwire,
        description: "Reports missing routed traces between pads in a net.",
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designators: {
                name: "Designators",
                field: "designators",
                isLink: true,
                isDefault: true,
                index: 0,
                width: "50%",
                fullViewWidth: "50%",
            },
            rcl_stock: {
                name: "Net",
                field: "net",
                isDefault: true,
                isLink: true,
                index: 1,
                width: "50%",
                fullViewWidth: "50%",
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckFloatingCopper]: {
        name: "Floating Copper",
        type: types_1.ReviewType.DesignRuleCheckFloatingCopper,
        description: "Detect any via, trace or copper fill island that is not connected to any net.",
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designators: {
                name: "Name",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckOverlappingCopper]: {
        name: "Overlapping Copper",
        type: types_1.ReviewType.DesignRuleCheckOverlappingCopper,
        description: "Reports copper elements that are shorting.",
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator_1: {
                name: "Des",
                field: "designator1",
                isDefault: true,
                isLink: true,
                index: 0,
                width: "20%",
                fullViewWidth: "16.67%",
            },
            rcl_net_1: {
                name: "Net",
                field: "net1",
                isDefault: true,
                isLink: true,
                index: 1,
                width: "30%",
                fullViewWidth: "16.67%",
            },
            rcl_layer_1: {
                name: "Layer",
                field: "layer1",
                isDefault: false,
                isLink: false,
                index: 2,
                fullViewWidth: "16.67%",
            },
            rcl_designator_2: {
                name: "Des",
                field: "designator2",
                isLink: true,
                isDefault: true,
                index: 3,
                width: "20%",
                fullViewWidth: "16.67%",
            },
            rcl_net_2: {
                name: "Net",
                field: "net2",
                isDefault: true,
                isLink: true,
                index: 4,
                width: "30%",
                fullViewWidth: "16.67%",
            },
            rcl_layer_2: {
                name: "Layer",
                field: "layer2",
                isDefault: false,
                isLink: false,
                index: 5,
                fullViewWidth: "16.66%",
            },
        },
    },
    /** @deprecated Use DesignRuleCheckOverlappingCopper instead */
    [types_1.ReviewType.DesignRuleCheckOverlappingTraces]: {
        name: "Overlapping Traces",
        type: types_1.ReviewType.DesignRuleCheckOverlappingTraces,
        description: "Reports trace collisions. Deprecated: use Overlapping Copper instead.",
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.INTERNAL,
        columns: {
            rcl_designator: {
                name: "Traces",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckComponentOverrides]: {
        name: "Component Overrides",
        type: types_1.ReviewType.DesignRuleCheckComponentOverrides,
        description: 'Reports components that have been modified using the "!important" flag.',
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Designator",
                field: "designator",
                isLink: true,
                isDefault: true,
                index: 0,
            },
            rcl_rule_set: {
                name: "Ruleset",
                field: "ruleSet",
                isLink: true,
                isDefault: true,
                index: 1,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckMissingFootprints]: {
        name: "Missing Footprints",
        type: types_1.ReviewType.DesignRuleCheckMissingFootprints,
        description: "Reports components that need a footprint but don't have one.",
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Designator",
                field: "designator",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckInvalidLayer]: {
        name: "Invalid Layer",
        type: types_1.ReviewType.DesignRuleCheckInvalidLayer,
        description: "Reports nodes that are assigned to a layer that doesn't exist in the layout stackup.",
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Designator",
                field: "designator",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckOverlappingFills]: {
        name: "Layers with Multiple Fills",
        type: types_1.ReviewType.DesignRuleCheckOverlappingFills,
        description: "Reports layers that have multiple copper fills of different nets. Make sure the Connected Layers rule value of nets with fills is valid.",
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_layer: {
                name: "Layer",
                field: "layer",
                isLink: false,
                isDefault: true,
                index: 0,
            },
            rcl_net: {
                name: "Net",
                field: "net",
                isLink: true,
                isDefault: true,
                index: 1,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckDeprecatedRules]: {
        name: "Deprecated Rules",
        type: types_1.ReviewType.DesignRuleCheckDeprecatedRules,
        description: "Reports nodes that are using rules that are not supported anymore.",
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Designator",
                field: "designator",
                isLink: true,
                isDefault: true,
                index: 0,
            },
            rcl_rule: {
                name: "Rule",
                field: "rule",
                isDefault: true,
                index: 1,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckTraceCornerRadius]: {
        name: "Trace Corner Radius",
        type: types_1.ReviewType.DesignRuleCheckTraceCornerRadius,
        description: "Reports traces that are unable to receive their specified minimum corner radii.",
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Name",
                field: "name",
                width: "50%",
                fullViewWidth: "50%",
                isDefault: true,
                isLink: true,
                index: 0,
            },
            rcl_net: {
                name: "Net",
                field: "net",
                width: "50%",
                fullViewWidth: "50%",
                isDefault: true,
                isLink: true,
                index: 1,
            },
        },
    },
    [types_1.ReviewType.SystemChecksAutoLayout]: {
        name: "Auto-Layout",
        type: types_1.ReviewType.SystemChecksAutoLayout,
        description: "Reports issues with Auto-Layout if Flux cannot route something or must ignore a configuration.",
        category: types_1.ReviewCategoryType.SystemChecks,
        availability: types_1.ReviewAvailability.BETA,
        columns: {
            rcl_object: {
                name: "Object",
                field: "object",
                isLink: true,
                isDefault: true,
                index: 0,
            },
            rcl_issue: {
                name: "Issue",
                field: "issue",
                isDefault: true,
                index: 1,
            },
            rcl_cause: {
                name: "Cause",
                field: "cause",
                isDefault: false,
                index: 2,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckProtectedIntrusions]: {
        name: "Protected Intrusions",
        type: types_1.ReviewType.DesignRuleCheckProtectedIntrusions,
        description: "Reports intrusions from objects of other nets into polygons or fills that have the Protected layout rule applied.",
        category: types_1.ReviewCategoryType.DesignRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_protected: {
                name: "Protected",
                field: "protected",
                isLink: true,
                isDefault: true,
                index: 0,
                width: "50%",
                fullViewWidth: "50%",
            },
            rcl_intruder: {
                name: "Intruder",
                field: "intruder",
                align: types_1.ReviewColumnAlign.RIGHT,
                isDefault: true,
                isLink: true,
                index: 1,
                width: "50%",
                fullViewWidth: "50%",
            },
        },
    },
    // ERC (Electrical Rule Check) validators
    [types_1.ReviewType.DesignRuleCheckErcDriverConflict]: {
        name: "Driver Conflicts",
        type: types_1.ReviewType.DesignRuleCheckErcDriverConflict,
        description: "Reports nets with multiple drivers that may conflict.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Components",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcDuplicateReference]: {
        name: "Duplicate Designators",
        type: types_1.ReviewType.DesignRuleCheckErcDuplicateReference,
        description: "Reports components with identical designators.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Components",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcFloatingPin]: {
        name: "Floating Pin",
        type: types_1.ReviewType.DesignRuleCheckErcFloatingPin,
        description: "Reports input pins that are not connected to any net.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Component",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcNoConnect]: {
        name: "No-Connect Violation",
        type: types_1.ReviewType.DesignRuleCheckErcNoConnect,
        description: "Reports no-connect pins that are connected.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Component",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcPinToPin]: {
        name: "Pin-to-Pin Conflicts",
        type: types_1.ReviewType.DesignRuleCheckErcPinToPin,
        description: "Reports incompatible pin connections on the same net based on electrical pin types.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Components",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcShortedComponents]: {
        name: "Shorted Components",
        type: types_1.ReviewType.DesignRuleCheckErcShortedComponents,
        description: "Reports any 2-pin component with both pins connected to the same net.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Component",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
            rcl_net: {
                name: "Net",
                field: "net",
                isLink: true,
                isDefault: true,
                index: 1,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcPowerPin]: {
        name: "Missing Power",
        type: types_1.ReviewType.DesignRuleCheckErcPowerPin,
        description: "Reports power input pins that are not connected to a power source.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_pin: {
                name: "Pin",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
            rcl_net: {
                name: "Net",
                field: "net",
                isLink: true,
                isDefault: true,
                index: 1,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcSimilarLabels]: {
        name: "Designator Conflicts",
        type: types_1.ReviewType.DesignRuleCheckErcSimilarLabels,
        description: "Reports net designators that are identical or differ only in case.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Designators",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcSinglePinNet]: {
        name: "Single Pin Nets",
        type: types_1.ReviewType.DesignRuleCheckErcSinglePinNet,
        description: "Reports nets that have only one pin connected.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_net: {
                name: "Net",
                field: "net",
                isLink: true,
                isDefault: true,
                index: 0,
            },
            rcl_pin: {
                name: "Pin",
                field: "pin",
                isLink: false,
                isDefault: true,
                index: 1,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcUndrivenNet]: {
        name: "Undriven Nets",
        type: types_1.ReviewType.DesignRuleCheckErcUndrivenNet,
        description: "Reports nets that have no driving pin (output, power output, or bidirectional).",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Components",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    // Additional ERC validators
    [types_1.ReviewType.DesignRuleCheckErcWireDangling]: {
        name: "Wire Dangling",
        type: types_1.ReviewType.DesignRuleCheckErcWireDangling,
        description: "Reports wires that have an unconnected endpoint.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Wire",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcUnconnectedWireEndpoint]: {
        name: "Unconnected Wire Endpoint",
        type: types_1.ReviewType.DesignRuleCheckErcUnconnectedWireEndpoint,
        description: "Reports wire endpoints that are not connected to any pin or other wire.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Wire",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcUnannotated]: {
        name: "Missing Designator",
        type: types_1.ReviewType.DesignRuleCheckErcUnannotated,
        description: "Reports components without a designator.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Component",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcSimilarPower]: {
        name: "Similar Power",
        type: types_1.ReviewType.DesignRuleCheckErcSimilarPower,
        description: "Reports power net names that differ only in case.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Power Nets",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcSimilarLabelAndPower]: {
        name: "Similar Designator and Power",
        type: types_1.ReviewType.DesignRuleCheckErcSimilarLabelAndPower,
        description: "Reports designators that are similar to power net names.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Designators",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcDifferentUnitFootprint]: {
        name: "Different Unit Footprint",
        type: types_1.ReviewType.DesignRuleCheckErcDifferentUnitFootprint,
        description: "Reports multi-unit components where units have different footprints.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Component",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcDifferentUnitNet]: {
        name: "Different Unit Net",
        type: types_1.ReviewType.DesignRuleCheckErcDifferentUnitNet,
        description: "Reports multi-unit components where corresponding pins are on different nets.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Component",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
    [types_1.ReviewType.DesignRuleCheckErcDifferentUnitValue]: {
        name: "Different Unit Value",
        type: types_1.ReviewType.DesignRuleCheckErcDifferentUnitValue,
        description: "Reports multi-unit components where units have different values.",
        category: types_1.ReviewCategoryType.ElectricalRuleChecks,
        availability: types_1.ReviewAvailability.RELEASED,
        columns: {
            rcl_designator: {
                name: "Component",
                field: "name",
                isLink: true,
                isDefault: true,
                index: 0,
            },
        },
    },
};
//# sourceMappingURL=constants.js.map